import Axios from 'axios'
import { headers } from '../../../../utilities/token'

export const GET_RENTAL_INQUIRIES = 'GET_RENTAL_INQUIRIES'
export const GET_RENTAL_INQUIRIES_FULFILLED = 'GET_RENTAL_INQUIRIES_FULFILLED'
export const GET_RENTAL_INQUIRIES_REJECTED = 'GET_RENTAL_INQUIRIES_REJECTED'

export const POST_RENTAL_INQUIRIES = 'POST_RENTAL_INQUIRIES'
export const POST_RENTAL_INQUIRIES_FULFILLED = 'POST_RENTAL_INQUIRIES_FULFILLED'
export const POST_RENTAL_INQUIRIES_REJECTED = 'POST_RENTAL_INQUIRIES_REJECTED'

export const PUT_RENTAL_INQUIRIES = 'PUT_RENTAL_INQUIRIES'
export const PUT_RENTAL_INQUIRIES_FULFILLED = 'PUT_RENTAL_INQUIRIES_FULFILLED'
export const PUT_RENTAL_INQUIRIES_REJECTED = 'PUT_RENTAL_INQUIRIES_REJECTED'

export const DELETE_RENTAL_INQUIRIES = 'DELETE_RENTAL_INQUIRIES'
export const DELETE_RENTAL_INQUIRIES_FULFILLED = 'DELETE_RENTAL_INQUIRIES_FULFILLED'
export const DELETE_RENTAL_INQUIRIES_REJECTED = 'DELETE_RENTAL_INQUIRIES_REJECTED'

const API_URL = process.env.REACT_APP_API_BASE_URL

export const loadRentalInquiries = (pagination) => {
  return dispatch => {
    dispatch({
      type: GET_RENTAL_INQUIRIES,
      payload: {}
    })
    return Axios.get(`${API_URL}/inquiries?page=${pagination.page}&limit=${pagination.limit}&searchTerm=${pagination.searchTerm}`, { headers: headers })
      .then(function (response) {
        dispatch({
          type: GET_RENTAL_INQUIRIES_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: GET_RENTAL_INQUIRIES_REJECTED,
          payload: error
        })
      })
  }
}

export const submitRentalInquiries = (data) => {
  return dispatch => {
    dispatch({
      type: POST_RENTAL_INQUIRIES,
      payload: {}
    })
    return Axios.post(`${API_URL}/inquiry`, { ...data }, { headers: headers })
      .then(function (response) {
        dispatch({
          type: POST_RENTAL_INQUIRIES_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        dispatch({
          type: POST_RENTAL_INQUIRIES_REJECTED,
          payload: error
        })
      })
  }
}

export const updateRentalInquiries = (data) => {
  return dispatch => {
    dispatch({
      type: PUT_RENTAL_INQUIRIES,
      payload: {}
    })
    return Axios.put(`${API_URL}/inquiry/${data.id}`, { ...data }, { headers: headers })
      .then(function (response) {
        return dispatch({
          type: PUT_RENTAL_INQUIRIES_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        return dispatch({
          type: PUT_RENTAL_INQUIRIES_REJECTED,
          payload: error
        })
      })
  }
}


export const deleteRentalInquiries = (id) => {
  return dispatch => {
    dispatch({
      type: DELETE_RENTAL_INQUIRIES,
      payload: {}
    })
    return Axios.delete(`${API_URL}/inquiry/${id}`, { headers: headers })
      .then(function (response) {
        return dispatch({
          type: DELETE_RENTAL_INQUIRIES_FULFILLED,
          payload: response.data
        })
      })
      .catch(function (error) {
        return dispatch({
          type: DELETE_RENTAL_INQUIRIES_REJECTED,
          payload: error
        })
      })
  }
}











